<template>
  <div v-if="show">
    <div
      v-if="mix.showNutritionTable"
      class="px-4 pb-2 text-white text-sm"
    >
      <p class="mb-0 p-1 font-medium text-xs">
        {{ t('per') }}:
      </p>
      <table class="table-base table-borderless mb-0 text-xs text-white">
        <tbody>
          <tr>
            <td class="px-1 pt-1 pb-0">
              {{ t('energy_value') }}
            </td>
            <td class="px-1 pt-1 pb-0 text-right">
              {{ mix.nutrients.energy }} kJ / {{ mix.nutrients.energyKcal }} kcal
            </td>
          </tr>
          <tr>
            <td class="px-1 pt-1 pb-0">
              {{ t('fats') }}
            </td>
            <td class="px-1 pt-1 pb-0 text-right">
              {{ mix.nutrients.fats }} g
            </td>
          </tr>
          <tr>
            <td class="px-1 pt-1 pb-0">
              {{ t('of_which_saturated_fatty_acids') }}
            </td>
            <td class="px-1 pt-1 pb-0 text-right">
              {{ mix.nutrients.saturatedFats }} g
            </td>
          </tr>
          <tr>
            <td class="px-1 pt-1 pb-0">
              {{ t('carbohydrates') }}
            </td>
            <td class="px-1 pt-1 pb-0 text-right">
              {{ mix.nutrients.carbohydrates }} g
            </td>
          </tr>
          <tr>
            <td class="px-1 pt-1 pb-0">
              {{ t('of_which_sugars') }}
            </td>
            <td class="px-1 pt-1 pb-0 text-right">
              {{ mix.nutrients.sugars }} g
            </td>
          </tr>
          <tr>
            <td class="px-1 pt-1 pb-0">
              {{ t('fiber') }}
            </td>
            <td class="px-1 pt-1 pb-0 text-right">
              {{ mix.nutrients.fibre }} g
            </td>
          </tr>
          <tr>
            <td class="px-1 pt-1 pb-0">
              {{ t('proteins') }}
            </td>
            <td class="px-1 pt-1 pb-0 text-right">
              {{ mix.nutrients.proteins }} g
            </td>
          </tr>
          <tr>
            <td class="px-1 pt-1 pb-0">
              {{ t('salt') }}
            </td>
            <td class="px-1 pt-1 pb-0 text-right">
              {{ mix.nutrients.salt }} g
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div
      v-else
      class="px-4 pb-2 text-white text-sm text-center"
    >
      <p>{{ t('nutrition_table_is_on_items') }}</p>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'

defineProps({
  mix: {
    type: Object,
    required: true,
  },

  show: {
    type: Boolean,
    default: false,
  },
})

const { t } = useI18n()
</script>

<i18n>
  {
    "cs": {
    "carbohydrates": "Sacharidy",
    "energy_value": "Energetická hodnota",
    "fats": "Tuky",
    "fiber": "Vláknina",
    "nutrition_table_is_on_items": "Nutriční tabulka je na položkách uvnitř balení.",
    "of_which_saturated_fatty_acids": "z toho nasycené mastné kyseliny",
    "of_which_sugars": "z toho cukry",
    "per": "na 100 g",
    "proteins": "Bílkoviny",
    "salt": "Sůl"
},
    "sk": {
    "carbohydrates": "Sacharidy",
    "energy_value": "Energia",
    "fats": "Tuky",
    "fiber": "Vláknina",
    "nutrition_table_is_on_items": "Nutričná tabuľka je na položkách vo vnútri balenia.",
    "of_which_saturated_fatty_acids": "z toho nasýtené mastné kyseliny",
    "of_which_sugars": "z toho cukry",
    "per": "na 100 g",
    "proteins": "Bielkoviny",
    "salt": "Soľ"
},
    "pl": {
    "carbohydrates": "Węglowodany",
    "energy_value": "Wartość energetyczna",
    "fats": "Tłuszcze",
    "fiber": "Błonnik",
    "nutrition_table_is_on_items": "Tabela wartości odżywczych znajduje się na produktach wewnątrz opakowania.",
    "of_which_saturated_fatty_acids": "w tym kwasy tłuszczowe nasycone",
    "of_which_sugars": "w tym cukry",
    "per": "w 100 g",
    "proteins": "Białko",
    "salt": "Sól"
},
    "hu": {
    "carbohydrates": "Szénhidrát",
    "energy_value": "Energiatartalom",
    "fats": "Zsírok",
    "fiber": "Rost",
    "nutrition_table_is_on_items": "A tápanyagtáblázat a csomagban található cikkeken van.",
    "of_which_saturated_fatty_acids": "ebből telített zsírsavak",
    "of_which_sugars": "ebből cukrok",
    "per": "100 g-ra",
    "proteins": "Fehérjék",
    "salt": "Só"
},
    "de": {
    "carbohydrates": "Kohlenhydrate",
    "energy_value": "Energiewert",
    "fats": "Fette",
    "fiber": "Ballaststoffe",
    "nutrition_table_is_on_items": "Die Nährwerttabelle befindet sich auf den Artikeln in der Verpackung.",
    "of_which_saturated_fatty_acids": "davon gesättigte Fettsäuren",
    "of_which_sugars": "davon Zucker",
    "per": "pro 100 g",
    "proteins": "Eiweiß",
    "salt": "Salz"
},
    "at": {
    "carbohydrates": "Kohlenhydrate",
    "energy_value": "Energiewert",
    "fats": "Fette",
    "fiber": "Ballaststoffe",
    "nutrition_table_is_on_items": "Die Nährwerttabelle befindet sich auf den Artikeln in der Verpackung.",
    "of_which_saturated_fatty_acids": "davon gesättigte Fettsäuren",
    "of_which_sugars": "davon Zucker",
    "per": "pro 100 g",
    "proteins": "Eiweiß",
    "salt": "Salz"
},
    "ro": {
    "carbohydrates": "Carbohidrați",
    "energy_value": "Valoare energetică",
    "fats": "Grăsimi",
    "fiber": "Fibre",
    "nutrition_table_is_on_items": "Tabelul nutrițional se află pe articolele din interiorul pachetului.",
    "of_which_saturated_fatty_acids": "din care acizi grași saturați",
    "of_which_sugars": "din care zaharuri",
    "per": "la 100 g",
    "proteins": "Proteine",
    "salt": "Sare"
},
    "fr": {
    "carbohydrates": "Glucides",
    "energy_value": "Valeur énergétique",
    "fats": "Matières grasses",
    "fiber": "Fibres alimentaires",
    "nutrition_table_is_on_items": "Le tableau nutritionnel se trouve sur les articles à l’intérieur de l’emballage.",
    "of_which_saturated_fatty_acids": "dont acides gras saturés",
    "of_which_sugars": "dont sucres",
    "per": "pour 100 g",
    "proteins": "Protéines",
    "salt": "Sel"
}
  }
</i18n>
